import React, { PureComponent } from "react";

import Select from "react-select";

import numeral from "numeral";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";

import { LineInput } from "components/Inputs/LineInput";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faCompressArrowsAlt,
  faExpandArrowsAlt,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import CrownIcon from "images/CrownIcon.svg";
import LightningBoltIcon from "images/lightningbolt.svg";
import WarningIcon from "images/warning.svg";

import { UNIFIED_PROJECT_STEPS } from "containers/Business/BusinessReducer";

import FunnelTooltip from "components/Business/ModelBox/FunnelTooltip";
import ModelLabels from "components/Business/ModelBox/ModelLabels";
import TinyBarChart from "components/Project/TinyBarChart";
import BusinessConstraints from "containers/Business/Strategy/BusinessConstraints";
import PieChart from "components/Project/PieChart";

import styles from "./style.module.css";

export default class MiniModelBox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      mode: "OVERVIEW",
      isDeployingProject: false,
      newScenarioName: "New Scenario",
      viewportWidth: 0,
      viewportHeight: 0
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight
    });
  }

  parseValueName(name) {
    if (name.includes("more than ") && name.includes(" to ")) {
      return name.replace("more than", ">");
    }
    return name;
  }

  getMaxRevenue(models) {
    const { data, setup } = this.props;

    return Math.max.apply(
      Math,
      models.map((m) => m.maxIteration.truePositive * setup.conversionGain)
    );
  }

  getMinRevenue(models) {
    const { data, setup } = this.props;

    return Math.min.apply(
      Math,
      models.map((m) => m.maxIteration.truePositive * setup.conversionGain)
    );
  }

  getMaxCost(models) {
    const { data, setup } = this.props;

    return Math.max.apply(
      Math,
      models.map((m) => Math.abs((m.maxIteration.truePositive + m.maxIteration.falsePositive) * setup.conversionCost))
    );
  }

  getMinCost(models) {
    const { data, setup } = this.props;

    return Math.min.apply(
      Math,
      models.map((m) => Math.abs((m.maxIteration.truePositive + m.maxIteration.falsePositive) * setup.conversionCost))
    );
  }

  getNewValue(oldValue, oldMax) {
    const { isSmall, strategy } = this.props;

    const { overallOnly, isOverallSegment } = this.props;
    const retWidth = isSmall || strategy ? 300 : 130;
    return ((oldValue - 0) * (retWidth - 0)) / (oldMax - 0) + 0;
  }

  getNewValueCapped(oldValue, oldMax, cap) {
    return ((oldValue - 0) * (cap - 0)) / (oldMax - 0) + 0;
  }

  getNewValueBar(oldValue, oldMin, oldMax) {
    return ((oldValue - oldMin) * (100 - 0)) / (oldMax - oldMin) + 0;
  }

  renderBadges(type) {
    const { allBusinessConstraints } = this.props;

    if (!allBusinessConstraints) {
      return;
    }

    return (
      <div className={styles.sBadgeHolder}>
        {allBusinessConstraints
          .filter((c) => c.primary && c.primary.type === type)
          .map((c, i) => {
            if (c.subgroup === "Overall") {
              return (
                <div className={styles.subBadge} style={{ background: c.color }}>
                  {"Strategy"}
                </div>
              );
            } else {
              return <div className={styles.subBullet} style={{ background: c.color }} />;
            }
          })}
      </div>
    );
  }

  renderFunnel() {
    const {
      id,
      isTraining,
      isSmall,
      isContinuous,
      isOverallSegment,
      optimized,
      overallOptimized,
      segmentConfusionMatrices,
      rSetup,
      modelGroups,
      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType,
      revenueLabel,
      profitLabel,
      project,
      truePositiveLabel,
      setupLabels,
      runId,
      nextId,
      showSubgroup,
      updateShowBusiness,
      updateShowImpact,
      showImpact,
      overallOnly,
      businessAssumptions,
      primaryBusinessConstraintType,
      currentStep,
      updateCurrentStep,
      strategy,
      showDelta,
      nextModelsHoverNode,
      isNext
    } = this.props;
    const { mode } = this.state;

    const isOptimizerRunning = project && project.settings ? project.settings.optimizerIsRunning : false;

    const activeSlice =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0]
        : undefined;

    const overallSlice = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues[0];

    const rMatrix = showSubgroup ? overallSlice.ccm : optimized ? optimized.constrainedConfusionMatrix : undefined;

    const setup = optimized && optimized.setup ? optimized.setup : rSetup;

    const rightSetup =
      showSubgroup && activeSlice && activeSlice.ccm
        ? {
            truePositive: activeSlice.ccm.tp,
            falsePositive: activeSlice.ccm.fp,
            trueNegative: activeSlice.ccm.tn,
            falseNegative: activeSlice.ccm.fn
          }
        : optimized && optimized.setup
          ? optimized.setup
          : rSetup;

    const cTotal = rightSetup
      ? rightSetup.truePositive + rightSetup.falsePositive + rightSetup.trueNegative + rightSetup.falseNegative
      : 0;
    const nTotal = rMatrix ? rMatrix.tp + rMatrix.fp + rMatrix.tn + rMatrix.fn : 0;

    const overallSetup =
      overallSlice && overallSlice.ccm
        ? {
            truePositive: overallSlice.ccm.tp,
            falsePositive: overallSlice.ccm.fp,
            trueNegative: overallSlice.ccm.tn,
            falseNegative: overallSlice.ccm.fn
          }
        : overallOptimized && overallOptimized.setup
          ? overallOptimized.setup
          : rSetup;

    const winRate = rMatrix && nTotal ? rMatrix.tp / nTotal : 0;

    const cWinRate = rightSetup && cTotal ? rightSetup.truePositive / cTotal : 0;

    const oldMax = Math.max(cTotal, nTotal);

    const leftColumnWidth = isSmall || strategy ? 160 : 130;

    const cLeads = this.getNewValueCapped(cTotal, oldMax, leftColumnWidth);
    const cOppsValue = rightSetup.truePositive + rightSetup.falsePositive;
    const cOpps = this.getNewValueCapped(cOppsValue, oldMax, leftColumnWidth);
    const cWins = this.getNewValueCapped(rightSetup.truePositive, oldMax, leftColumnWidth);

    const nLeads = this.getNewValue(nTotal, oldMax);
    const nOppsValue = rMatrix ? rMatrix.tp + rMatrix.fp : 0;
    const nOpps = this.getNewValue(nOppsValue, oldMax);
    const nWinsValue = rMatrix ? rMatrix.tp : 0;
    const nWins = this.getNewValue(rMatrix ? rMatrix.tp : 0, oldMax);

    const isZoomed = this.state.funnelZoom;
    const cScale = isZoomed && cOpps ? cLeads / cOpps : 1;
    const nScale = isZoomed && nOpps ? nLeads / nOpps : 1;

    const rDelta = optimized
      ? optimized.revenueDelta > 0
        ? (((optimized.revenue - optimized.currentRevenue) / optimized.currentRevenue) * 100).toFixed(1)
        : (((optimized.currentRevenue - optimized.revenue) / optimized.currentRevenue) * 100).toFixed(1)
      : 0;

    const isEmpty = showImpact !== true && setup.showImpact === undefined && setup.showBusiness === undefined;
    const isPercentage = showImpact !== true && setup.showImpact === undefined;

    const cEffort =
      rightSetup && cTotal ? Math.round(((rightSetup.truePositive + rightSetup.falsePositive) / cTotal) * 100) : 0;
    const nEffort = rMatrix && nTotal ? ((rMatrix.tp + rMatrix.fp) / nTotal) * 100 : 0;

    const activeColor =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId && d.column !== "Overall").length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0].color
        : "#7E69D7";

    const defaultGrey = showSubgroup ? activeSlice.color : "rgb(204, 204, 204)";

    let currentSegment =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId && d.column == "Overall").length > 0
        ? "Overall"
        : "Optimized";

    const percIncrease = (a, b) => {
      let percent;
      if (b !== 0) {
        if (a !== 0) {
          percent = ((b - a) / a) * 100;
        } else {
          return (
            <span className={styles.iFlex}>
              <span>{"+"}</span>
              <span className={styles.infSymbol}>{"∞"}</span>
            </span>
          );
        }
      } else {
        percent = -a * 100;
      }
      return percent.toFixed(2) + "%";
    };

    const subgroupCostDelta = showSubgroup
      ? optimized && isPercentage
        ? percIncrease(activeSlice.currentCost, activeSlice.cost)
        : optimized.totalCost - optimized.currentSpend &&
          `${optimized.totalCost - optimized.currentSpend > 0 ? "+" : "-"} ${setupLabels.unitType}${numeral(
            Math.abs(optimized.totalCost - optimized.currentSpend)
          ).format("0.0a")}`
      : "";
    const subgroupProfitDelta = showSubgroup
      ? optimized && isPercentage
        ? percIncrease(activeSlice.currentProfit, activeSlice.profit)
        : optimized &&
          optimized.profitDelta &&
          `${optimized.profitDelta > 0 ? "+" : "-"} ${
            setupLabels.unitType
          }${numeral(Math.abs(optimized.profitDelta)).format("0.0a")}`
      : "";
    const subgroupRevenueDelta = showSubgroup
      ? optimized && isPercentage
        ? percIncrease(activeSlice.currentRevenue, activeSlice.revenue)
        : optimized &&
          optimized.revenueDelta &&
          `${optimized.revenueDelta > 0 ? "+" : "-"} ${
            setupLabels.unitType
          }${numeral(Math.abs(optimized.revenueDelta)).format("0.0a")}`
      : "";

    const costDelta =
      isPercentage && overallOptimized
        ? percIncrease(overallOptimized.currentSpend, overallOptimized.totalCost)
        : showSubgroup
          ? overallOptimized && overallOptimized.totalCost - overallOptimized.currentSpend
            ? `${
                overallOptimized.totalCost - overallOptimized.currentSpend > 0 ? "+" : "-"
              } ${setupLabels.unitType}${numeral(
                Math.abs(overallOptimized.totalCost - overallOptimized.currentSpend)
              ).format("0.0a")}`
            : ""
          : optimized && optimized.totalCost - optimized.currentSpend
            ? `${optimized.totalCost - optimized.currentSpend > 0 ? "+" : "-"} ${setupLabels.unitType}${numeral(
                Math.abs(optimized.totalCost - optimized.currentSpend)
              ).format("0.0a")}`
            : "";

    const profitDiffLabel = showSubgroup
      ? overallOptimized &&
        overallOptimized.profitDelta &&
        `${overallOptimized.profitDelta > 0 ? "+" : "-"} ${
          setupLabels.unitType
        }${numeral(Math.abs(overallOptimized.profitDelta)).format("0.0a")}`
      : optimized &&
        optimized.profitDelta &&
        `${optimized.profitDelta > 0 ? "+" : "-"} ${
          setupLabels.unitType
        }${numeral(Math.abs(optimized.profitDelta)).format("0.0a")}`;

    const revenueDiffLabel =
      isPercentage && overallOptimized
        ? percIncrease(overallOptimized.currentRevenue, overallOptimized.revenue)
        : showSubgroup
          ? overallOptimized &&
            overallOptimized.revenueDelta &&
            `${overallOptimized.revenueDelta > 0 ? "+" : "-"} ${
              setupLabels.unitType
            }${numeral(Math.abs(overallOptimized.revenueDelta)).format("0.0a")}`
          : optimized &&
            optimized.revenueDelta &&
            `${optimized.revenueDelta > 0 ? "+" : "-"} ${
              setupLabels.unitType
            }${numeral(Math.abs(optimized.revenueDelta)).format("0.0a")}`;
    const allDriversAdded =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter(
        (group) => group && group.setup && group.column !== "Overall" && !group.setup.showImpact
      ).length;

    const numSegments = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length;

    const subgroupCounts = {
      leads: [],
      opps: [],
      wins: []
    };

    const currentSubgroupCounts = {
      leads: [],
      opps: [],
      wins: []
    };

    if (modelGroups && modelGroups.drilldownValues) {
      const otherSegments = modelGroups.drilldownValues.filter((d) => d.value !== "Overall");
      const retSCM = segmentConfusionMatrices || {};
      otherSegments.forEach((currSeg) => {
        const currSCM = retSCM[currSeg.segmentId];
        const currLeads = {
          value: currSCM ? ((currSCM.tp + currSCM.fp + currSCM.fn + currSCM.tn) / (nTotal || 1)) * 100 : 0,
          color: currSeg.color
        };
        const currOpps = {
          value: currSCM ? ((currSCM.tp + currSCM.fp) / (nOpps || 1)) * 100 : 0,
          color: currSeg.color
        };
        const currWins = {
          value: currSCM ? (currSCM.tp / (nWins || 1)) * 100 : 0,
          color: currSeg.color
        };
        subgroupCounts.leads.push(currLeads);
        subgroupCounts.opps.push(currOpps);
        subgroupCounts.wins.push(currWins);

        const baselineLeads = {
          value: currSCM
            ? ((currSeg.setup.truePositive +
                currSeg.setup.falsePositive +
                currSeg.setup.falseNegative +
                currSeg.setup.trueNegative) /
                (cTotal || 1)) *
              100
            : 0,
          color: currSeg.color
        };
        const baselineOpps = {
          value: currSCM ? ((currSeg.setup.truePositive + currSeg.setup.falsePositive) / (cOpps || 1)) * 100 : 0,
          color: currSeg.color
        };
        const baselineWins = {
          value: currSCM ? (currSeg.setup.truePositive / (cWins || 1)) * 100 : 0,
          color: currSeg.color
        };
        currentSubgroupCounts.leads.push(baselineLeads);
        currentSubgroupCounts.opps.push(baselineOpps);
        currentSubgroupCounts.wins.push(baselineWins);
      });
    }
    const generateBinValue = () => {
      let binValue = 1000;
      const opportunitiesOptimized = rightSetup.truePositive + rightSetup.falsePositive;
      const opportunitiesBaseline = rMatrix ? rMatrix.tp + rMatrix.fp : 0;
      let valuesToJudge = [
        cTotal,
        nTotal,
        opportunitiesOptimized,
        opportunitiesBaseline,
        rightSetup.truePositive,
        rMatrix ? rMatrix.tp : 0
      ];
      let minValue = Math.min(...valuesToJudge);
      if (minValue !== undefined) {
        if (minValue < 100) {
          binValue = 100;
        }
      }
      return binValue;
    };

    const generateBinValueByInput = (input1, input2) => {
      let binValue = 1000;

      let valuesToJudge = [input1, input2];
      let minValue = Math.max(...valuesToJudge);
      if (minValue !== undefined) {
        binValue = minValue / 20;
      }
      return binValue;
    };

    const generateBins = (currentValue, optimizedValue, unusedBinSize = 100, extraMargin = 0) => {
      //if (optimizedValue === 0 || currentValue === 0) {
      const margin = extraMargin > 0 ? 20 + extraMargin : 20;
      return <div style={{ height: `${margin}px` }}></div>;
      //}
      const binSize = generateBinValueByInput(currentValue, optimizedValue);
      const scale = currentValue > optimizedValue ? currentValue : optimizedValue;
      const maxBins = Math.min(20, Math.ceil(scale / binSize));
      const generateBins = (isOptimized, value, addExtraMargin = false) => {
        const numBins = Math.min(20, Math.ceil(value / binSize));

        const binsArray = new Array(Math.ceil(numBins)).fill(0);

        const style = isOptimized ? styles.measurementBarOptimized : styles.measurementBarBaseline;

        const containerStyle = isOptimized
          ? styles.measurementBarsContainerOptimized
          : styles.measurementBarsContainerCurrent;

        const binsToRender = binsArray.length;
        const binCssSize = 100 / binsToRender;

        const extraStyles = {
          width: `${Math.min(98, (numBins / maxBins) * 100)}%`
        };
        if (addExtraMargin) {
          extraStyles.marginTop = `${extraMargin}px`;
        }
        return (
          <FunnelTooltip
            tooltipText={
              <div>
                <span style={{ fontWeight: "bold" }}>{`${isOptimized ? "Optimized: " : "Baseline: "}`}</span>
                {Math.round(value)}
              </div>
            }
          >
            <div className={containerStyle} style={extraStyles}>
              {binsArray.map((bin, index) => {
                return <div key={index} className={style} style={{ minWidth: `calc(${binCssSize}% - 1px)` }}></div>;
              })}
            </div>
          </FunnelTooltip>
        );
      };
      return (
        <React.Fragment>
          {generateBins(true, optimizedValue, true)}
          {generateBins(false, currentValue)}
        </React.Fragment>
      );
    };

    const isFullHeightModelBox = this.state.viewportHeight > 875;

    return (
      <React.Fragment>
        <div
          className={isSmall ? styles.smallContent : styles.mContent}
          style={
            nextModelsHoverNode?.id === "OPTIMIZE_TRANSACTION" ||
            nextModelsHoverNode?.id === "OPTIMIZE_COSTS" ||
            nextModelsHoverNode?.id === "OPTIMIZE_STRATEGY"
              ? {
                  height: "auto",
                  paddingBottom: "20px",
                  background: "rgba(243, 242, 253, 1)"
                }
              : nextId !== undefined
                ? { height: "auto", paddingBottom: "20px" }
                : {}
          }
        >
          {/*isEmpty === true && (
          <a
            className={isSmall ? styles.eAbsSmall : styles.eAbs}
            onClick={isSmall ? () => {} : () => updateShowBusiness(true)}
          >
            {"Add business objectives to see the optimized effort"}
          </a>
        )*/}

          {overallOnly && (
            <ModelLabels
              mode={mode}
              optimized={optimized}
              setupLabels={setupLabels}
              overallOnly={overallOnly}
              modelGroups={modelGroups}
            />
          )}
          {isSmall === true ? (
            <div />
          ) : setup === undefined ? (
            <div className={styles.mColumn}>{"EMPTY"}</div>
          ) : (
            <div className={strategy ? styles.mColumnCompare : styles.mColumn}>
              <div className={styles.mSubTitle}>{showSubgroup ? activeSlice.value : "Baseline"}</div>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Total " + (setupLabels ? setupLabels.notPursuedTransactionLabel : "") + ": "}
                    </span>
                    {Math.round(cTotal)}
                  </div>
                }
              >
                <div className={styles.modelBarHolder} style={{ marginTop: "5px" }}>
                  <div
                    className={styles.modelBar + " " + styles.subgroupModels}
                    style={{
                      width: cLeads + "px",
                      background: numSegments > 1 ? "" : defaultGrey,
                      opacity: numSegments > 1 ? 1 : 0.6,
                      transform: `scaleX(${cScale})`
                    }}
                  >
                    {currentSubgroupCounts.leads.map((currSubgroup, i) => (
                      <div
                        key={i}
                        className={styles.subgroupModelBar}
                        style={{
                          width: currSubgroup.value + "%",
                          background: isOverallSegment !== true ? activeSlice?.color + "60" : currSubgroup.color + "90"
                        }}
                      />
                    ))}
                  </div>

                  <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
                </div>
              </FunnelTooltip>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {setupLabels ? setupLabels.notPursuedTransactionLabel + " " + setupLabels.falseAction + ": " : ""}
                    </span>
                    {setup ? Math.round(rightSetup.trueNegative + rightSetup.falseNegative) : ""}
                  </div>
                }
              >
                <div className={styles.modelBarHolder}>
                  <div
                    className={styles.modelBar}
                    style={{
                      width: cLeads + "px",
                      borderLeft: (cLeads - cOpps) / 2 + "px solid transparent",
                      borderRight: (cLeads - cOpps) / 2 + "px dotted transparent",
                      borderTop: "40px solid " + defaultGrey,
                      opacity: 0.2,
                      transform: `scaleX(${cScale})`
                    }}
                  />
                  <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
                </div>
              </FunnelTooltip>

              <div className={styles.modelBarHolder}>
                <FunnelTooltip
                  tooltipText={
                    <div>
                      <span style={{ fontWeight: "700" }}>
                        {"Total " + (setupLabels ? setupLabels.transactionLabel : "") + ": "}
                      </span>
                      {Math.round(rightSetup.truePositive + rightSetup.falsePositive)}
                    </div>
                  }
                >
                  <div
                    className={styles.modelBar + " " + styles.subgroupModels}
                    style={{
                      width: cOpps * cScale + "px",
                      background: numSegments > 1 ? "" : defaultGrey,
                      opacity: numSegments > 1 ? 1 : 0.8
                    }}
                  >
                    {currentSubgroupCounts.opps.map((currSubgroup, i) => (
                      <div
                        key={i}
                        className={styles.subgroupModelBar}
                        style={{
                          width: currSubgroup.value + "%",
                          background: isOverallSegment !== true ? activeSlice?.color + "60" : currSubgroup.color + "90"
                        }}
                      />
                    ))}
                  </div>
                </FunnelTooltip>
              </div>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {(setupLabels ? setupLabels.transactionLabel : "") +
                        " not " +
                        (setupLabels ? setupLabels.outcomeLabel + ": " : "")}
                    </span>
                    {setup ? Math.round(rightSetup.falsePositive) : ""}
                  </div>
                }
              >
                <div className={styles.modelBarHolder}>
                  <div
                    className={styles.modelBar}
                    style={{
                      width: cOpps * cScale + "px",
                      borderLeft: ((cOpps - cWins) / 2) * cScale + "px solid transparent",
                      borderRight: ((cOpps - cWins) / 2) * cScale + "px dotted transparent",
                      borderTop: "40px solid " + defaultGrey,
                      opacity: 0.3
                    }}
                  />
                </div>
              </FunnelTooltip>
              <div className={styles.modelBarHolder}>
                <FunnelTooltip
                  tooltipText={
                    <div>
                      <span style={{ fontWeight: "700" }}>
                        {setupLabels ? setupLabels.transactionLabel + " " + setupLabels.outcomeLabel + ": " : ""}
                      </span>
                      {Math.round(rightSetup.truePositive)}
                    </div>
                  }
                >
                  <div
                    className={styles.modelBar + " " + styles.subgroupModels}
                    style={{
                      width: cWins * cScale + "px",
                      background: numSegments > 1 ? "" : defaultGrey
                    }}
                  >
                    {currentSubgroupCounts.wins.map((currSubgroup, i) => (
                      <div
                        key={i}
                        className={styles.subgroupModelBar}
                        style={{
                          width: currSubgroup.value + "%",
                          background: isOverallSegment !== true ? activeSlice?.color + "60" : currSubgroup.color + "90"
                        }}
                      />
                    ))}
                  </div>
                </FunnelTooltip>
              </div>
            </div>
          )}
          {
            <div className={isSmall ? styles.mColumn : strategy ? styles.mColumnCompare : styles.mColumn}>
              <div className={isNext ? styles.nextMMiddle : styles.mMiddle} style={{ marginTop: "21px" }}>
                {setupLabels.notPursuedTransactionLabel}
              </div>
              {generateBins(cTotal, nTotal, 1000)}
              <div
                className={isNext ? styles.nextMMiddle : styles.mMiddle}
                style={{
                  height: "19px",
                  marginLeft: "6px",
                  marginRight: "6px"
                }}
              >
                <a className={styles.mLink} onClick={() => this.setState({ funnelZoom: !this.state.funnelZoom })}>
                  <FontAwesomeIcon
                    style={{ marginRight: "6px" }}
                    icon={this.state.funnelZoom ? faCompressArrowsAlt : faExpandArrowsAlt}
                  />
                  {setupLabels.transactionLabel + " to " + setupLabels.trueAction}
                </a>
              </div>
              {generateBins(
                rightSetup.truePositive + rightSetup.falsePositive,
                rMatrix ? rMatrix.tp + rMatrix.fp : 0,
                1000,
                15
              )}
              <div className={isNext ? styles.nextMMiddle : styles.mMiddle}>{setupLabels.outcomeLabel}</div>
              {generateBins(rightSetup.truePositive, rMatrix ? rMatrix.tp : 0, 1000)}
            </div>
          }
          <div
            className={isSmall ? styles.mColumnFull : strategy ? styles.mColumnFullCompare : styles.mColumn}
            style={overallOnly ? { width: "calc(100% - 145px" } : {}}
          >
            <div className={styles.mSubTitle}>{"Aible Optimized"}</div>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    {"Total " + (setupLabels ? setupLabels.notPursuedTransactionLabel : "") + ": "}
                  </span>
                  {Math.round(nTotal)}
                </div>
              }
            >
              <div className={styles.modelBarHolder} style={{ marginTop: "5px" }}>
                <div
                  className={styles.modelBar + " " + styles.subgroupModels}
                  style={{
                    width: nLeads + "px",
                    background: activeColor,
                    opacity: 0.6,
                    transform: `scaleX(${nScale})`
                  }}
                >
                  {subgroupCounts.leads.map((currSubgroup, i) => (
                    <div
                      key={i}
                      className={styles.subgroupModelBar}
                      style={{
                        width: currSubgroup.value + "%",
                        background: isOverallSegment !== true ? activeSlice?.color : currSubgroup.color
                      }}
                    />
                  ))}
                </div>

                <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
              </div>
            </FunnelTooltip>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    {setupLabels ? setupLabels.transactionLabel + " " + setupLabels.falseAction + ": " : ""}
                  </span>
                  {rMatrix ? Math.round(rMatrix.tn + rMatrix.fn) : ""}
                </div>
              }
            >
              <div className={styles.modelBarHolder}>
                <div
                  className={styles.modelBar}
                  style={{
                    width: nLeads + "px",
                    borderLeft: (nLeads - nOpps) / 2 + "px solid transparent",
                    borderRight: (nLeads - nOpps) / 2 + "px dotted transparent",
                    borderTop: " 40px solid " + activeColor,
                    opacity: 0.2,
                    transform: `scaleX(${nScale})`
                  }}
                />
                <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
              </div>
            </FunnelTooltip>
            <div className={styles.modelBarHolder}>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Total " + (setupLabels ? setupLabels.transactionLabel : "") + ": "}
                    </span>
                    {rMatrix ? Math.round(rMatrix.tp + rMatrix.fp) : 0}
                  </div>
                }
              >
                <div
                  className={styles.modelBar + " " + styles.subgroupModels}
                  style={{
                    width: nOpps * nScale + "px",
                    background: activeColor,
                    opacity: 0.8
                  }}
                >
                  {subgroupCounts.opps.map((currSubgroup, i) => (
                    <div
                      key={i}
                      className={styles.subgroupModelBar}
                      style={{
                        width: currSubgroup.value + "%",
                        background: isOverallSegment !== true ? activeSlice?.color : currSubgroup.color
                      }}
                    />
                  ))}
                </div>
              </FunnelTooltip>
            </div>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    {(setupLabels ? setupLabels.transactionLabel : "") +
                      " not " +
                      (setupLabels ? setupLabels.outcomeLabel + ": " : "")}
                  </span>
                  {rMatrix ? Math.round(rMatrix.fp) : ""}
                </div>
              }
            >
              <div className={styles.modelBarHolder}>
                <div
                  className={styles.modelBar}
                  style={{
                    width: nOpps * nScale + "px",
                    borderLeft: ((nOpps - nWins) / 2) * nScale + "px solid transparent",
                    borderRight: ((nOpps - nWins) / 2) * nScale + "px dotted transparent",
                    borderTop: " 40px solid " + activeColor,
                    opacity: 0.3
                  }}
                />
              </div>
            </FunnelTooltip>
            <div className={styles.modelBarHolder}>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {setupLabels ? setupLabels.transactionLabel + " " + setupLabels.outcomeLabel + ": " : ""}
                    </span>
                    {rMatrix ? Math.round(rMatrix.tp) : 0}
                  </div>
                }
              >
                <div
                  className={styles.modelBar + " " + styles.subgroupModels}
                  style={{
                    width: nWins * nScale + "px",
                    background: activeColor
                  }}
                >
                  {subgroupCounts.wins.map((currSubgroup, i) => (
                    <div
                      key={i}
                      className={styles.subgroupModelBar}
                      style={{
                        width: currSubgroup.value + "%",
                        background: isOverallSegment !== true ? activeSlice?.color : currSubgroup.color
                      }}
                    />
                  ))}
                </div>
              </FunnelTooltip>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderMonitoringFunnel() {
    const {
      data,
      isSmall,
      isOverallSegment,
      optimized,
      segmentConfusionMatrices,
      rSetup,
      modelGroups,
      setupLabels,
      runId,
      nextId,
      showSubgroup,
      overallOnly,
      strategy,
      nextModelsHoverNode,
      isNext,
      segmentId
    } = this.props;
    const { mode } = this.state;

    let graphData = segmentId && data[segmentId] && data[segmentId].data;
    if (graphData) graphData = graphData[graphData.length - 1];

    if (!graphData) {
      return <div style={{ fontWeight: "bold" }}>No Monitoring Data Found</div>;
    }

    const activeSlice =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0]
        : undefined;

    const rMatrix = graphData ? graphData.cumulativeConfusionMatrix : undefined;
    const setup = optimized && optimized.setup ? optimized.setup : rSetup;

    const rightSetup = graphData &&
      graphData.cumulativeConfusionMatrix && {
        truePositive: graphData.cumulativeAssumedConfusionMatrix.tp,
        falsePositive: graphData.cumulativeAssumedConfusionMatrix.fp,
        trueNegative: graphData.cumulativeAssumedConfusionMatrix.tn,
        falseNegative: graphData.cumulativeAssumedConfusionMatrix.fn
      };

    const cTotal = rightSetup
      ? rightSetup.truePositive + rightSetup.falsePositive + rightSetup.trueNegative + rightSetup.falseNegative
      : 0;
    const nTotal = rMatrix ? rMatrix.tp + rMatrix.fp + rMatrix.tn + rMatrix.fn : 0;

    const oldMax = Math.max(cTotal, nTotal);

    const leftColumnWidth = isSmall || strategy ? 160 : 130;

    const cLeads = this.getNewValueCapped(cTotal, oldMax, leftColumnWidth);
    const cOppsValue = rightSetup.truePositive + rightSetup.falsePositive;
    const cOpps = this.getNewValueCapped(cOppsValue, oldMax, leftColumnWidth);
    const cWins = this.getNewValueCapped(rightSetup.truePositive, oldMax, leftColumnWidth);

    const nLeads = this.getNewValue(nTotal, oldMax);
    const nOppsValue = rMatrix ? rMatrix.tp + rMatrix.fp : 0;
    const nOpps = this.getNewValue(nOppsValue, oldMax);
    const nWinsValue = rMatrix ? rMatrix.tp : 0;
    const nWins = this.getNewValue(rMatrix ? rMatrix.tp : 0, oldMax);

    const isZoomed = this.state.funnelZoom;
    const cScale = isZoomed && cOpps ? cLeads / cOpps : 1;
    const nScale = isZoomed && nOpps ? nLeads / nOpps : 1;

    const activeColor =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId && d.column !== "Overall").length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0].color
        : "#7E69D7";

    const defaultGrey = showSubgroup ? activeSlice.color : "rgb(204, 204, 204)";

    const percIncrease = (a, b) => {
      let percent;
      if (b !== 0) {
        if (a !== 0) {
          percent = ((b - a) / a) * 100;
        } else {
          return (
            <span className={styles.iFlex}>
              <span>{"+"}</span>
              <span className={styles.infSymbol}>{"∞"}</span>
            </span>
          );
        }
      } else {
        percent = -a * 100;
      }
      return percent.toFixed(2) + "%";
    };

    const numSegments = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length;

    const subgroupCounts = {
      leads: [],
      opps: [],
      wins: []
    };

    const currentSubgroupCounts = {
      leads: [],
      opps: [],
      wins: []
    };

    if (data) {
      const otherSegments = Object.keys(data)
        .map((segmentId) => data[segmentId])
        .filter((d) => d.data?.length > 0 && d.data[0].label !== "Overall");
      const retSCM = segmentConfusionMatrices || {};
      otherSegments.forEach((currSeg) => {
        const currSCM = currSeg.data[currSeg.data.length - 1].cumulativeConfusionMatrix;
        const segment =
          modelGroups &&
          modelGroups.drilldownValues &&
          modelGroups.drilldownValues.find((seg) => seg.segmentId === currSeg.segmentId);

        const segmentColor = segment && segment.color ? segment.color : "rgb(126, 105, 215)";
        const currLeads = {
          value: currSCM ? ((currSCM.tp + currSCM.fp + currSCM.fn + currSCM.tn) / (nTotal || 1)) * 100 : 0,
          color: segmentColor
        };
        const currOpps = {
          value: currSCM ? ((currSCM.tp + currSCM.fp) / (nOpps || 1)) * 100 : 0,
          color: segmentColor
        };
        const currWins = {
          value: currSCM ? (currSCM.tp / (nWins || 1)) * 100 : 0,
          color: segmentColor
        };
        subgroupCounts.leads.push(currLeads);
        subgroupCounts.opps.push(currOpps);
        subgroupCounts.wins.push(currWins);
        const actualSCM = currSeg.data[currSeg.data.length - 1].cumulativeAssumedConfusionMatrix;
        currSCM;
        const baselineLeads = {
          value: actualSCM ? ((actualSCM.tp + actualSCM.fn + actualSCM.tn + actualSCM.fp) / (cTotal || 1)) * 100 : 0,
          color: segmentColor
        };
        const baselineOpps = {
          value: currSCM ? ((actualSCM.tp + actualSCM.fp) / (cOpps || 1)) * 100 : 0,
          color: segmentColor
        };
        const baselineWins = {
          value: currSCM ? (actualSCM.tp / (cWins || 1)) * 100 : 0,
          color: segmentColor
        };
        currentSubgroupCounts.leads.push(baselineLeads);
        currentSubgroupCounts.opps.push(baselineOpps);
        currentSubgroupCounts.wins.push(baselineWins);
      });
    }

    const generateBinValueByInput = (input1, input2) => {
      let binValue = 1000;

      let valuesToJudge = [input1, input2];
      let minValue = Math.max(...valuesToJudge);
      if (minValue !== undefined) {
        binValue = minValue / 20;
      }
      return binValue;
    };

    const generateBins = (currentValue, optimizedValue, unusedBinSize = 100, extraMargin = 0) => {
      //if (optimizedValue === 0 && currentValue === 0) {
      const margin = extraMargin > 0 ? 40 + extraMargin : 40;
      return <div style={{ height: `${margin}px` }}></div>;
      //}
      const binSize = generateBinValueByInput(currentValue, optimizedValue);
      const scale = currentValue > optimizedValue ? currentValue : optimizedValue;
      const maxBins = Math.min(20, Math.ceil(scale / binSize));
      const generateBins = (isOptimized, value, addExtraMargin = false) => {
        const numBins = Math.min(20, Math.ceil(value / binSize));

        const binsArray = new Array(Math.ceil(numBins)).fill(0);

        const style = isOptimized ? styles.measurementBarOptimized : styles.measurementBarBaseline;

        const containerStyle = isOptimized
          ? styles.measurementBarsContainerOptimized
          : styles.measurementBarsContainerCurrent;

        const binsToRender = binsArray.length;
        const binCssSize = 100 / binsToRender;

        const extraStyles = {
          width: `${Math.min(98, (numBins / maxBins) * 100)}%`
        };
        if (addExtraMargin) {
          extraStyles.marginTop = `${extraMargin}px`;
        }
        return (
          <FunnelTooltip
            tooltipText={
              <div>
                <span style={{ fontWeight: "bold" }}>{`${isOptimized ? "Actual: " : "Expected: "}`}</span>
                {Math.round(value)}
              </div>
            }
          >
            <div className={containerStyle} style={extraStyles}>
              {binsArray.map((bin, index) => {
                return <div key={index} className={style} style={{ minWidth: `calc(${binCssSize}% - 1px)` }}></div>;
              })}
            </div>
          </FunnelTooltip>
        );
      };
      return (
        <React.Fragment>
          {generateBins(true, optimizedValue, true)}
          {generateBins(false, currentValue)}
        </React.Fragment>
      );
    };

    const isFullHeightModelBox = this.state.viewportHeight > 875;

    return (
      <React.Fragment>
        <div
          className={isSmall ? styles.smallContent : styles.mContent}
          style={
            nextModelsHoverNode?.id === "OPTIMIZE_TRANSACTION" ||
            nextModelsHoverNode?.id === "OPTIMIZE_COSTS" ||
            nextModelsHoverNode?.id === "OPTIMIZE_STRATEGY"
              ? {
                  height: "auto",
                  paddingBottom: "20px",
                  background: "rgba(243, 242, 253, 1)"
                }
              : nextId !== undefined
                ? { height: "auto", paddingBottom: "20px" }
                : {}
          }
        >
          {/*isEmpty === true && (
          <a
            className={isSmall ? styles.eAbsSmall : styles.eAbs}
            onClick={isSmall ? () => {} : () => updateShowBusiness(true)}
          >
            {"Add business objectives to see the optimized effort"}
          </a>
        )*/}

          {overallOnly && (
            <ModelLabels
              mode={mode}
              optimized={optimized}
              setupLabels={setupLabels}
              overallOnly={overallOnly}
              modelGroups={modelGroups}
            />
          )}
          {isSmall === true ? (
            <div />
          ) : setup === undefined ? (
            <div className={styles.mColumn}>{"EMPTY"}</div>
          ) : (
            <div className={strategy ? styles.mColumnCompare : styles.mColumn}>
              <div className={styles.mSubTitle}>{"Expected"}</div>
              <div className={styles.modelBarHolder} style={{ marginTop: "5px" }}>
                <FunnelTooltip
                  tooltipText={
                    <div>
                      <span style={{ fontWeight: "700" }}>
                        {"Total " + (setupLabels ? setupLabels.notPursuedTransactionLabel : "") + ": "}
                      </span>
                      {Math.round(cTotal)}
                    </div>
                  }
                >
                  <div
                    className={styles.modelBar + " " + styles.subgroupModels}
                    style={{
                      width: cLeads + "px",
                      background: numSegments > 1 ? "" : defaultGrey,
                      opacity: numSegments > 1 ? 1 : 0.6,
                      transform: `scaleX(${cScale})`
                    }}
                  >
                    {currentSubgroupCounts.leads.map((currSubgroup, i) => (
                      <div
                        key={i}
                        className={styles.subgroupModelBar}
                        style={{
                          width: currSubgroup.value + "%",
                          background: isOverallSegment !== true ? activeSlice?.color + "60" : currSubgroup.color + "90"
                        }}
                      />
                    ))}
                  </div>
                </FunnelTooltip>
                <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
              </div>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {setupLabels ? setupLabels.notPursuedTransactionLabel + " " + setupLabels.falseAction + ": " : ""}
                    </span>
                    {setup ? Math.round(rightSetup.trueNegative + rightSetup.falseNegative) : ""}
                  </div>
                }
              >
                <div className={styles.modelBarHolder}>
                  <div
                    className={styles.modelBar}
                    style={{
                      width: cLeads + "px",
                      borderLeft: (cLeads - cOpps) / 2 + "px solid transparent",
                      borderRight: (cLeads - cOpps) / 2 + "px dotted transparent",
                      borderTop: "40px solid " + defaultGrey,
                      opacity: 0.2,
                      transform: `scaleX(${cScale})`
                    }}
                  />
                  <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
                </div>
              </FunnelTooltip>

              <div className={styles.modelBarHolder}>
                <FunnelTooltip
                  tooltipText={
                    <div>
                      <span style={{ fontWeight: "700" }}>
                        {"Total " + (setupLabels ? setupLabels.transactionLabel : "") + ": "}
                      </span>
                      {Math.round(rightSetup.truePositive + rightSetup.falsePositive)}
                    </div>
                  }
                >
                  <div
                    className={styles.modelBar + " " + styles.subgroupModels}
                    style={{
                      width: cOpps * cScale + "px",
                      background: numSegments > 1 ? "" : defaultGrey,
                      opacity: numSegments > 1 ? 1 : 0.8
                    }}
                  >
                    {currentSubgroupCounts.opps.map((currSubgroup, i) => (
                      <div
                        key={i}
                        className={styles.subgroupModelBar}
                        style={{
                          width: currSubgroup.value + "%",
                          background: isOverallSegment !== true ? activeSlice?.color + "60" : currSubgroup.color + "90"
                        }}
                      />
                    ))}
                  </div>
                </FunnelTooltip>
              </div>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {(setupLabels ? setupLabels.transactionLabel : "") +
                        " not " +
                        (setupLabels ? setupLabels.outcomeLabel + ": " : "")}
                    </span>
                    {setup ? Math.round(rightSetup.falsePositive) : ""}
                  </div>
                }
              >
                <div className={styles.modelBarHolder}>
                  <div
                    className={styles.modelBar}
                    style={{
                      width: cOpps * cScale + "px",
                      borderLeft: ((cOpps - cWins) / 2) * cScale + "px solid transparent",
                      borderRight: ((cOpps - cWins) / 2) * cScale + "px dotted transparent",
                      borderTop: "40px solid " + defaultGrey,
                      opacity: 0.3
                    }}
                  />
                </div>
              </FunnelTooltip>
              <div className={styles.modelBarHolder}>
                <FunnelTooltip
                  tooltipText={
                    <div>
                      <span style={{ fontWeight: "700" }}>
                        {setupLabels ? setupLabels.transactionLabel + " " + setupLabels.outcomeLabel + ": " : ""}
                      </span>
                      {Math.round(rightSetup.truePositive)}
                    </div>
                  }
                >
                  <div
                    className={styles.modelBar + " " + styles.subgroupModels}
                    style={{
                      width: cWins * cScale + "px",
                      background: numSegments > 1 ? "" : defaultGrey
                    }}
                  >
                    {currentSubgroupCounts.wins.map((currSubgroup, i) => (
                      <div
                        key={i}
                        className={styles.subgroupModelBar}
                        style={{
                          width: currSubgroup.value + "%",
                          background: isOverallSegment !== true ? activeSlice?.color + "60" : currSubgroup.color + "90"
                        }}
                      />
                    ))}
                  </div>
                </FunnelTooltip>
              </div>
            </div>
          )}
          {
            <div className={isSmall ? styles.mColumn : strategy ? styles.mColumnCompare : styles.mColumn}>
              <div className={isNext ? styles.nextMMiddle : styles.mMiddle} style={{ marginTop: "21px" }}>
                {setupLabels.notPursuedTransactionLabel}
              </div>
              {generateBins(cTotal, nTotal, 1000)}
              <div
                className={isNext ? styles.nextMMiddle : styles.mMiddle}
                style={{
                  height: "19px",
                  marginLeft: "6px",
                  marginRight: "6px"
                }}
              >
                <div>{setupLabels.transactionLabel + " to " + setupLabels.trueAction}</div>
                {/* <a
                  className={styles.mLink}
                  onClick={() =>
                    this.setState({ funnelZoom: !this.state.funnelZoom })
                  }
                >
                  <FontAwesomeIcon
                    style={{ marginRight: "6px" }}
                    icon={
                      this.state.funnelZoom
                        ? faCompressArrowsAlt
                        : faExpandArrowsAlt
                    }
                  />
                  {setupLabels.transactionLabel +
                    " to " +
                    setupLabels.trueAction}
                </a> */}
              </div>
              {generateBins(
                rightSetup.truePositive + rightSetup.falsePositive,
                rMatrix ? rMatrix.tp + rMatrix.fp : 0,
                1000,
                15
              )}
              <div className={isNext ? styles.nextMMiddle : styles.mMiddle}>{setupLabels.outcomeLabel}</div>
              {generateBins(rightSetup.truePositive, rMatrix ? rMatrix.tp : 0, 1000)}
            </div>
          }
          <div
            className={isSmall ? styles.mColumnFull : strategy ? styles.mColumnFullCompare : styles.mColumn}
            style={overallOnly ? { width: "calc(100% - 145px" } : {}}
          >
            <div className={styles.mSubTitle}>{"Actual"}</div>
            <div className={styles.modelBarHolder} style={{ marginTop: "5px" }}>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Total " + (setupLabels ? setupLabels.notPursuedTransactionLabel : "") + ": "}
                    </span>
                    {Math.round(nTotal)}
                  </div>
                }
              >
                <div
                  className={styles.modelBar + " " + styles.subgroupModels}
                  style={{
                    width: nLeads + "px",
                    background: activeColor,
                    opacity: 0.6,
                    transform: `scaleX(${nScale})`
                  }}
                >
                  {subgroupCounts.leads.map((currSubgroup, i) => (
                    <div
                      key={i}
                      className={styles.subgroupModelBar}
                      style={{
                        width: currSubgroup.value + "%",
                        background: isOverallSegment !== true ? activeSlice?.color : currSubgroup.color
                      }}
                    />
                  ))}
                </div>
              </FunnelTooltip>
              <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
            </div>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    {setupLabels ? setupLabels.transactionLabel + " " + setupLabels.falseAction + ": " : ""}
                  </span>
                  {rMatrix ? Math.round(rMatrix.tn + rMatrix.fn) : ""}
                </div>
              }
            >
              <div className={styles.modelBarHolder}>
                <div
                  className={styles.modelBar}
                  style={{
                    width: nLeads + "px",
                    borderLeft: (nLeads - nOpps) / 2 + "px solid transparent",
                    borderRight: (nLeads - nOpps) / 2 + "px dotted transparent",
                    borderTop: " 40px solid " + activeColor,
                    opacity: 0.2,
                    transform: `scaleX(${nScale})`
                  }}
                />
                <div className={styles.modelBarMask} style={{ opacity: isZoomed ? 1 : 0 }} />
              </div>
            </FunnelTooltip>
            <div className={styles.modelBarHolder}>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {"Total " + (setupLabels ? setupLabels.transactionLabel : "") + ": "}
                    </span>
                    {rMatrix ? Math.round(rMatrix.tp + rMatrix.fp) : 0}
                  </div>
                }
              >
                <div
                  className={styles.modelBar + " " + styles.subgroupModels}
                  style={{
                    width: nOpps * nScale + "px",
                    background: activeColor,
                    opacity: 0.8
                  }}
                >
                  {subgroupCounts.opps.map((currSubgroup, i) => (
                    <div
                      key={i}
                      className={styles.subgroupModelBar}
                      style={{
                        width: currSubgroup.value + "%",
                        background: isOverallSegment !== true ? activeSlice?.color : currSubgroup.color
                      }}
                    />
                  ))}
                </div>
              </FunnelTooltip>
            </div>
            <FunnelTooltip
              tooltipText={
                <div>
                  <span style={{ fontWeight: "700" }}>
                    {(setupLabels ? setupLabels.transactionLabel : "") +
                      " not " +
                      (setupLabels ? setupLabels.outcomeLabel + ": " : "")}
                  </span>
                  {rMatrix ? Math.round(rMatrix.fp) : ""}
                </div>
              }
            >
              <div className={styles.modelBarHolder}>
                <div
                  className={styles.modelBar}
                  style={{
                    width: nOpps * nScale + "px",
                    borderLeft: ((nOpps - nWins) / 2) * nScale + "px solid transparent",
                    borderRight: ((nOpps - nWins) / 2) * nScale + "px dotted transparent",
                    borderTop: " 40px solid " + activeColor,
                    opacity: 0.3
                  }}
                />
              </div>
            </FunnelTooltip>
            <div className={styles.modelBarHolder}>
              <FunnelTooltip
                tooltipText={
                  <div>
                    <span style={{ fontWeight: "700" }}>
                      {setupLabels ? setupLabels.transactionLabel + " " + setupLabels.outcomeLabel + ": " : ""}
                    </span>
                    {rMatrix ? Math.round(rMatrix.tp) : 0}
                  </div>
                }
              >
                <div
                  className={styles.modelBar + " " + styles.subgroupModels}
                  style={{
                    width: nWins * nScale + "px",
                    background: activeColor
                  }}
                >
                  {subgroupCounts.wins.map((currSubgroup, i) => (
                    <div
                      key={i}
                      className={styles.subgroupModelBar}
                      style={{
                        width: currSubgroup.value + "%",
                        background: isOverallSegment !== true ? activeSlice?.color : currSubgroup.color
                      }}
                    />
                  ))}
                </div>
              </FunnelTooltip>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { isMonitoring } = this.props;

    return <div>{isMonitoring ? this.renderMonitoringFunnel() : this.renderFunnel()}</div>;
  }
}
